import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import { RESPONSE_STATUS } from '@Pages/Login/ResetPasswordWithTokenDialog/ResetPasswordWithTokenDialogConstants';

function ResetPasswordWithTokenDialogFooter({ submit, close, responseStatus }) {
  const isLoading = responseStatus === RESPONSE_STATUS.LOADING;
  const isSuccess = responseStatus === RESPONSE_STATUS.SUCCESS;
  const isError = responseStatus === RESPONSE_STATUS.ERROR;

  // Don't show footer buttons in error state
  if (isError) {
    return null;
  }

  return (
    <div className="reset-password-with-token-dialog__footer u-els-padding-top">
      {isSuccess ? (
        <Button type="primary" expanded data-e2e="reset-password-with-token-success" onClick={close}>
          OK, got it
        </Button>
      ) : (
        <Button type="primary" expanded data-e2e="reset-password-with-token-continue" disabled={isLoading} onClick={submit}>
          Save
        </Button>
      )}
    </div>
  );
}

ResetPasswordWithTokenDialogFooter.propTypes = {
  submit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  responseStatus: PropTypes.string,
};

export default ResetPasswordWithTokenDialogFooter;
